import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-result_circle_check",
  "use": "icon-result_circle_check-usage",
  "viewBox": "0 0 84 84",
  "content": "<symbol viewBox=\"0 0 84 84\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-result_circle_check\"><clipPath id=\"icon-result_circle_check_a\"><path d=\"m0 0h84v84h-84z\" /></clipPath><g clip-path=\"url(#icon-result_circle_check_a)\"><path d=\"m10.5 42c0 17.4 14.1 31.5 31.5 31.5s31.5-14.1 31.5-31.5-14.1-31.5-31.5-31.5-31.5 14.1-31.5 31.5z\" fill=\"#00B279\" /><path d=\"m38.5 51c-.5 0-1-.2-1.4-.6l-7-7c-.8-.8-.8-2 0-2.8s2-.8 2.8 0l5.6 5.6 12.6-12.6c.8-.8 2-.8 2.8 0s.8 2 0 2.8l-14 14c-.4.4-.9.6-1.4.6z\" fill=\"#fff\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/result_circle_check.svg
// module id = yzH1
// module chunks = 87